'use client';

import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { trackMetaEvent } from '@/components/MetaPixel';

// Fires Meta "CompleteRegistration" once per browser for a freshly created account — covers both
// e-mail sign-up and the Google OAuth redirect (which never returns to the sign-up handler).
// "Fresh" = auth user created less than 15 minutes ago.
const KEY = 'smt_reg_pinged';

export default function RegistrationPixelPing() {
  const { user } = useAuth();
  useEffect(() => {
    if (!user?.created_at) return;
    try {
      if (localStorage.getItem(KEY)) return;
      const ageMs = Date.now() - Date.parse(user.created_at);
      if (ageMs < 0 || ageMs > 15 * 60 * 1000) return;
      trackMetaEvent('CompleteRegistration', { content_name: user.app_metadata?.provider || 'email' });
      localStorage.setItem(KEY, '1');
    } catch { /* storage blocked — skip */ }
  }, [user]);
  return null;
}
